<!--
 * @Description: 价税合计弹层
 * @Date: 2025-10-31 09:55:43
-->
<template>
  <BaseDialog
    width="880px"
    title="发票金额"
    :model-value="true"
    :show-close="true"
    :close-on-press-escape="true"
    :close-on-click-modal="false"
    :showFooter="false"
  >
    <BaseTextContent>
      <XrkTable
        ref="xrkTableRef"
        :getListAjax="getListAjax"
        :searchConfig="searchConfig"
        :tableConfig="tableConfig"
      >
        <template #tableBefore>
          <ul
            class="table__before__stats"
            style="padding: 10px 0; justify-content: center; flex-wrap: wrap"
          >
            <li class="table__before__stats--selected">
              价税合计：
              <span>{{ formatter.fen2yuan(invoiceAmount) }}元</span>
            </li>
          </ul>
        </template>
      </XrkTable>
    </BaseTextContent>
  </BaseDialog>
</template>
<script lang="tsx" setup>
import { ref } from 'vue';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  BaseDialog,
  BaseTextContent,
  BaseButton
} from 'xrk-components';
import { formatter } from '@/utils';
import { queryInvoiceOrder } from '@V/invoice/src/data-source/apis';
import { STATE_TYPE } from '@constants/order';
import { useJumpToOrderDetail } from '@hooks/order';

const props = withDefaults(
  defineProps<{
    remove?: () => {};
    invoiceApplyId: number;
    invoiceBusinessType: number;
  }>(),
  {}
);

const xrkTableRef = ref();
const invoiceAmount = ref(0);

const getListAjax = async params => {
  const resp = await queryInvoiceOrder({ ...params, ...props });
  invoiceAmount.value = resp.data.invoiceAmount;
  return resp;
};

const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchColumns: [],
  searchBtn: { show: false },
  resetBtn: { show: false }
});

const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: 'index',
      label: '序号',
      width: '80px',
      fixed: 'left'
    }),
    useTableColumn({
      label: '对应订单编号',
      prop: 'orderNo',
      width: '240px'
    }),
    useTableColumn({
      label: '订单类型',
      prop: 'orderType',
      width: '180px',
      formatter: ({ cellValue }) =>
        formatter.defaultFormat(cellValue, () => STATE_TYPE[cellValue].label)
    }),

    useTableColumn({
      label: '订单金额(元)',
      prop: 'orderAmount',
      width: '180px',
      render({ row, cellValue }) {
        return (
          <BaseButton
            link
            onClick={() => {
              useJumpToOrderDetail(row.orderNo, { method: 'open' });
            }}
          >
            {formatter.fen2yuan(cellValue)}
          </BaseButton>
        );
      }
    }),
    useTableColumn({
      label: '收款时间',
      prop: 'payAt',
      formatter: ({ cellValue }) => formatter.date(cellValue)
    })
  ]
});
</script>
